import React, { useEffect, useState } from 'react';
import { ErrorSpan } from './error-span.component';

interface IInputProps {
  placeholder: string;
  errors: any;
  name: string;
  register: any;
  type: string;
  label: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

export const Input = ({
  placeholder,
  errors,
  name,
  register,
  type,
  label,
  icon,
  children,
  className = ''
}: IInputProps) => {
  const [isPassword, setIsPassword] = useState(false);
  const [inputType, setInputType] = useState(type);

  useEffect(() => {
    if (type === 'password') {
      setIsPassword(true);
    }
  }, [type]);

  const togglePassword = () => {
    setInputType((prev) => (prev === 'password' ? 'text' : 'password'));
  };

  return (
    <div className="relative">
      <label
        htmlFor={name}
        className="text-base-black dark:text-white font-body text-[14px] ml-[6px] font-medium"
      >
        {label}
      </label>

      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-[31px] -translate-y-1/2 pointer-events-none">
            {icon}
          </div>
        )}

        <input
          placeholder={placeholder}
          type={inputType}
          {...register(name)}
          className={`w-full md:max-w-[392px] h-[44px] mt-[8px] mb-[22px] ${isPassword ? 'pr-[48px]' : 'pr-[40px]'} pl-[44px] py-[11px]
            text-[16px] font-body font-regular text-base-black dark:text-white bg-white dark:bg-[#28282B]
            border rounded-[24px] placeholder-gray-900 dark:placeholder-[#6B6B6F] placeholder:font-body
            focus:outline-none
            ${
              errors[name]
                ? 'border-red-500 text-red-500 placeholder-red-500'
                : 'border-gray-700 dark:border-[rgba(255,255,255,0.12)] hover:border-[#BFBFC0] hover:bg-white dark:hover:bg-[#28282B] focus:border-[#BFBFC0] focus:bg-white dark:focus:bg-[#28282B] focus:shadow-[0_0_0_4px_rgba(29,29,30,0.12)] dark:focus:border-[#5DE1FF]/40 dark:focus:shadow-[0_0_0_4px_rgba(93,225,255,0.12)]'
            }
            ${className}`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={togglePassword}
            style={{ top: 'calc(8px + 22px)' }}
            className="absolute right-[14px] -translate-y-1/2 text-[#818185] dark:text-[#A0A0A3] hover:text-base-black dark:hover:text-white transition-colors"
          >
            {inputType === 'password' ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            )}
          </button>
        )}
      </div>

      {children}
      {errors[name] && <ErrorSpan>{errors[name].message}</ErrorSpan>}
    </div>
  );
};
